var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat-empty widget card pa h-100 d-flex align-center justify-center flex-column"},[_c('ChatStartModal'),_c('img',{staticClass:"mt-10",staticStyle:{"width":"100%","max-width":"500px"},attrs:{"src":require('@/assets/images/quick-chat.svg'),"alt":"Chat illustration"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }